import { isNil } from 'ramda';

/**
 * @deprecated use isNumber from enmon-commons instead
 */
export const isNumber = (value: unknown): value is number => !isNil(value) && typeof value === 'number';
